'use client';

import React from 'react';
import { ExperienceType } from '../types';
import TargetAudience from '@/components/packages/TargetAudience';
import { TravellerType } from '@/types/activityDetailsTypes';

interface ExperienceTargetAudienceProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceTargetAudience: React.FC<
  ExperienceTargetAudienceProps
> = ({ experience, type }) => {
  if (!experience || type !== 'package') return null;

  const exp = experience as {
    travellerTypes?: TravellerType[];
    targetAudience?: TravellerType[];
  };

  const types = exp?.travellerTypes || exp?.targetAudience || [];

  if (!Array.isArray(types) || types.length === 0) return null;

  return <TargetAudience types={types} />;
};
